import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { personPost } from '../../api'
import { ImageUpload } from '../../common/attachments/imageupload'
import { Button } from '../../common/Button.tsx'

export default function ProfileImageModal({ show, setShow, hasImage, personData, refreshPersonData }) {
	const { t } = useTranslation()
	const [currentImage, setCurrentImage] = useState(personData?.otherDetails?.image || '')

	const handleClearImage = async () => {
		const updated = {
			...personData,
			otherDetails: {
				...personData.otherDetails,
				image: '',
			},
		}

		await personPost(updated)
		refreshPersonData()
		setCurrentImage('')
	}

	return (
		<Modal show={show} onHide={() => setShow(false)} centered>
			<Modal.Header closeButton>
				<Modal.Title>
					{hasImage ? t('EditProfileImage', 'Muokkaa profiilikuvaa') : t('AddProfileImage', 'Lisää profiilikuva')}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<ImageUpload
					currentImage={currentImage}
					entityId={personData?.personId}
					savedKey={async (imageKey) => {
						const updated = {
							...personData,
							otherDetails: { ...personData.otherDetails, image: imageKey },
						}
						await personPost(updated)
						refreshPersonData()
						setCurrentImage(imageKey)
						setShow(false)
					}}
				/>

				{currentImage && (
					<div className="d-flex justify-content-end mt-3">
						<Button testId="clear-profile-image" variant="outline-danger" onClick={handleClearImage}>
							{t('ClearProfileImage', 'Tyhjennä kuva')}
						</Button>
					</div>
				)}
			</Modal.Body>
		</Modal>
	)
}
